import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import CreateCycle from "./routes/CreateCycle";
import CycleDetails from "./routes/CycleDetails";
import { injectReducer } from "store/reducers";
export default store => ({
  path: "snp_v2",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "snpV2" */ "./components"),
        import(/* webpackChunkName: "snpV2" */ "SnP_v2/modules/SnPModule"),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "snpV2",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [CreateCycle(store), CycleDetails(store)],
});
